import type { AnyAction } from 'redux';
import { enqueueNotification } from '../../notifications/actions';
import type { Dispatcher, StateType } from '../../storeTypes';

import {
  createFetchedBrandIdsAction,
  createLoadBrandsOptionsAction,
  createLoadOptionsBeginAction,
  createSearchBrandsBeginAction,
  createSearchBrandsFinishAction,
} from './actions';
import * as api from './api';
import type { BaseState } from './reducer';

export function loadBrandsOptions(ids: string[]): Dispatcher<StateType & BaseState> {
  return async (dispatch, getState) => {
    const alreadyLoadedBrandsOptions = getState().brands.brandsSearch.options;
    const newIds = ids.filter(id => !alreadyLoadedBrandsOptions[id]);

    if (newIds.length) {
      dispatch(createLoadOptionsBeginAction());
      const brands = await api.fetchBrands(newIds);
      dispatch(createLoadBrandsOptionsAction(brands) as AnyAction);
      dispatch(createFetchedBrandIdsAction(newIds) as AnyAction);
    }
  };
}

export function searchBrands(phrase: string): Dispatcher<StateType & BaseState> {
  return async (dispatch, getState) => {
    if (!phrase) {
      dispatch(createSearchBrandsFinishAction([]) as AnyAction);
      return;
    }

    dispatch(createSearchBrandsBeginAction(phrase) as AnyAction);

    try {
      const brands = await api.searchBrands(phrase);
      dispatch(createLoadBrandsOptionsAction(brands) as AnyAction);
      dispatch(createFetchedBrandIdsAction(brands.map(brand => brand.id)) as AnyAction);

      if (phrase === getState().brands.brandsSearch.searchPhrase) {
        dispatch(createSearchBrandsFinishAction(brands) as AnyAction);
      }
    } catch (error) {
      dispatch(
        enqueueNotification({
          message: error.message,
          options: { variant: 'error' },
        }) as AnyAction
      );
      dispatch(createSearchBrandsFinishAction([]) as AnyAction);
    }
  };
}

export function clearSearchBrandsResults(): Dispatcher<StateType & BaseState> {
  return dispatch => {
    dispatch(createSearchBrandsFinishAction([]) as AnyAction);
  };
}
